import { useDispatch, useSelector } from "react-redux";
import "./UpNextPosts.scss";
import { Link, useParams } from "react-router-dom";
import { useEffect } from "react";
import { getUpNextPosts } from "../../redux/features/post/postSlice";

const UpNextPost = () => {
  const { identifier } = useParams();

  const dispatch = useDispatch();
  useEffect(() => {
    if (identifier) {
      dispatch(getUpNextPosts(identifier));
    }
  }, [dispatch, identifier]);

  const { upNextPosts } = useSelector((state) => state.post);

  const next = upNextPosts
    ?.filter((post) => {
      return post;
    })
    ?.filter((post, index) => index < 5);

  //   const next = Array.isArray(upNextPosts)
  //     ? upNextPosts.filter((post) => post.views > 0).slice(0, 5)
  //     : [];

  return (
    <div className="most-read">
      <h3>Up next</h3>
      <ul className="most-read__list">
        {next.length > 0 ? (
          next.map((post) => (
            <li key={post._id} className="most-read__item">
              <Link to={`/page/${post.slug}`}>{post.title}</Link>
            </li>
          ))
        ) : (
          <p className="most-read__empty">No next posts yet.</p>
        )}
      </ul>
    </div>
  );
};

export default UpNextPost;
